var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-class page-setting-list"},[_c('div',{staticClass:"page-title text-center"},[_c('h2',[_vm._v(_vm._s(_vm.title))])]),_c('table-box',{attrs:{"columns":_vm.columns,"rows":_vm.summaryBudget,"baseUrl":_vm.baseUrl,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }